<template>



	<el-form v-if="form" label-width="15em">
		<el-form-item label="id">
			<el-input v-model="form.id" disabled></el-input>
		</el-form-item>


		<el-form-item label="username">
			<el-input v-model="form.username" :disabled="mode!='create'"></el-input>
		</el-form-item>

		<el-form-item label="password">
			<el-input v-model="form.password"></el-input>
		</el-form-item>


		<el-form-item>
			<el-button type="primary" @click="submit">save</el-button>
		</el-form-item>
	</el-form>
</template>

<script>
	import ImageUpload from '@/components/ImageUpload'
	import mixin from '@/utils/mixin';
	export default {
		mixins: [mixin],
		components: {
			ImageUpload,
		},
		data() {
			return {
				form: {},
				places: [
					'HOME_SWIPER',
					'HOME_MENU',
					'HOME_TILE',
				]
			}
		},
		mounted() {
			this.form = {
				...this.propForm
			}
		},
		methods: {

			close() {
				this.$emit('close');
			},
			submit() {
				if (this.mode == 'create') {
					request({
						url: '/api/user/createStationAdmin',
						data: {
							...this.form,
						},
						success: resp => {
							Message.success();
							this.$emit('success')
						}
					})
				} else if (this.mode == 'update') {
					request({
						url: '/api/user/updateStationAdmin',
						data: {
							...this.form,
						},
						success: resp => {
							Message.success();
							this.$emit('success')
						}
					})
				}
			},


		}
	}
</script>

<style>

</style>